import { getRuneEntry } from "./runes-extended";

export const RUNE_TREES: { id: number; nameRu: string; nameEn: string }[] = [
  { id: 8100, nameRu: "Доминация", nameEn: "Domination" },
  { id: 8300, nameRu: "Вдохновение", nameEn: "Inspiration" },
  { id: 8000, nameRu: "Точность", nameEn: "Precision" },
  { id: 8200, nameRu: "Колдовство", nameEn: "Sorcery" },
  { id: 8400, nameRu: "Храбрость", nameEn: "Resolve" },
];

export { ALL_RUNES, getRuneImageUrl, getRuneEntry } from "./runes-extended";
export type { RuneEntry } from "./runes-extended";

export function getRuneName(runeId: number, locale: string): string {
  const extended = getRuneEntry(runeId);
  if (extended) return extended.name;
  const rune = RUNE_TREES.find((r) => r.id === runeId);
  if (!rune) return `${runeId}`;
  return locale.startsWith("ru") ? rune.nameRu : rune.nameEn;
}
